import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ErrorService } from '@app/common/services/error.service';
import { PlexEnvironment } from '@app/env';
import { CEMImportTypes } from '@app/shared/models/cem-import-types';
import { ImportExportMetadata } from '@app/shared/models/import-export-metadata';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

export class BlobAndFile {

  constructor(response: HttpResponse<Blob>) {
    this.FileName = this.getFileNameFromHeader(response.headers);
    this.Blob = response.body;
  }

  public FileNameOrDefault(defaultFileName: string) {
    if (!this.FileName || !this.FileName.length) {
      return defaultFileName;
    }
    return this.FileName;
  }

  public Blob: Blob;
  public FileName: string;

  getFileNameFromHeader(header: HttpHeaders): string {
    let contentDisposition = header.get('Content-Disposition');
    if (contentDisposition) {
      let pattern = /filename=([^;]+)/;
      let fileNameParts = pattern.exec(contentDisposition);
      if (fileNameParts.length) {
        return fileNameParts.pop();
      }
    }
    return '';
  }
}

@Injectable({
  providedIn: 'root'
})
export class ImportExportService {
  private http = inject(HttpClient);
  private errorService = inject(ErrorService);
  public environment = inject(PlexEnvironment);


  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  getTemplateFile(scenarioId: number, parentBuildId: string, capitalForecastLogId: number, importType: CEMImportTypes, metaData: Array<ImportExportMetadata>): Observable<BlobAndFile> {

    let url = `${this.environment.apiUrl}uploadinputfile/Template?scenarioId=${scenarioId}&parentBuildId=${parentBuildId}&capitalForecastLogId=${capitalForecastLogId}&importType=${importType}`;
    let result = this.http.post(url, metaData, {
      responseType: 'blob',
      headers: this.headers,
      observe: 'response'
    });

    return result.pipe(
      map(x => new BlobAndFile(x)),
      catchError(e => {
        let errorMsg = e.headers?.get('custom-exception-message') ?? e.message;
        let stacktrace = e.headers?.get('custom-exception-stacktrace') ?? '';
        let error = new Error(errorMsg + '\n' + stacktrace);
        return this.errorService.handleHTTPError(error)
      })
    );
  }
}